//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.AECDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../Features/Features.AECDesign.BuildingElementTrimBuilder.js";
import "../Features/Features.AECDesign.LevelReferenceBuilder.js";
import "../Features/Features.AECDesign.MaterialSectionBuilder.js";
import "../no/Section.js";
import "../no/Expression.js";
import "../no/Features.js";
import "../no/Expression.js";
import "../no/Section.js";
let d=[[[1,"BuildingElementTrim",0,"Features.AECDesign.BuildingElementTrimBuilder",0],[1,"LevelReference",0,"Features.AECDesign.LevelReferenceBuilder",0],[1,"MaterialSection",0,"Features.AECDesign.MaterialSectionBuilder",0],[1,"PathGeometry",0,"Section",0],[0,"YAlignmentType",1,0],[1,"YOffset",0,"Expression",0],[0,"ZAlignmentType",1,0],[1,"ZOffset",0,"Expression",0]],[[[],"UpdateReferencedColumns",{},0,0]],[]];
SPLM.Features.AECDesign.BeamBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.AECDesign.BeamBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.AECDesign.BeamBuilder.HorizontalAlignmentTypes = Object.freeze({
    "LeftAligned" : "LeftAligned", "RightAligned" : "RightAligned", "CenterlineAligned" : "CenterlineAligned"});

SPLM.Features.AECDesign.BeamBuilder.VerticalAlignmentTypes = Object.freeze({
    "TopAligned" : "TopAligned", "BottomAligned" : "BottomAligned", "CenterlineAligned" : "CenterlineAligned"});

export default SPLM;